<template>
  <div>
    <el-form :inline="true">
      <!-- 添加/搜索区域 -->
      <el-form-item>
        <el-button @click="addVipLevel" type="primary">{{ $t('xinzeng') }}</el-button>
      </el-form-item>
      <!-- 列表区域 -->
      <el-form-item>
        <el-input
          v-model="queryinfo.query"
          :clearable="true"
          @clear="getlist"
          style="width:240px"
          placeholder="请输入等级名称或等级值"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getlist"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="vipLevelList" border style="width: 100%;">
      <el-table-column prop="id" label="#" width="60"></el-table-column>
      <el-table-column prop="level" label="VIP等级" width="100"></el-table-column>
      <el-table-column prop="name" label="等级名称"></el-table-column>
      <el-table-column prop="invest_amount" label="投资金额" width="150">
        <template slot-scope="scope">
          {{ scope.row.invest_amount }} USDT
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="180">
        <template slot-scope="scope">
          {{ formatDate(scope.row.create_time) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150px">
        <template slot-scope="{ row }">
          <el-tooltip
            content="编辑"
            placement="top"
            :enterable="false"
          >
            <i class="iconfont icon-bianji" @click="edit(row.id)"></i>
          </el-tooltip>
          <el-tooltip
            content="删除"
            placement="top"
            :enterable="false"
          >
            <i class="iconfont icon-shanchu" @click="deleteVipLevel(row.id)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <el-pagination
      :hide-on-single-page="total <= 10"
      background
      layout="prev, pager, next, total"
      :page-size="10"
      :total="total"
      :current-page="queryinfo.page"
      @current-change="changepage"
    ></el-pagination>
    <!-- 添加VIP等级弹窗区域 -->
    <el-dialog
      title="新增VIP等级"
      :visible.sync="addDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
    >
      <el-form :model="addForm" label-width="120px" ref="addFormRef" :rules="rules">
        <el-form-item label="VIP等级" prop="level">
          <el-input-number v-model="addForm.level" :min="1" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="等级名称" prop="name">
          <el-input v-model="addForm.name" placeholder="例如：青铜会员、白银会员"></el-input>
        </el-form-item>
        <el-form-item label="投资金额" prop="invest_amount">
          <el-input-number v-model="addForm.invest_amount" :precision="2" :step="100" :min="0" controls-position="right" style="width: 200px;"></el-input-number>
          <span class="unit">USDT</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSubmit">提交</el-button>
        <el-button @click="addDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑VIP等级弹窗区域 -->
    <el-dialog
      title="编辑VIP等级"
      :visible.sync="editDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editFormRef"
        :rules="rules"
      >
        <el-form-item label="VIP等级" prop="level">
          <el-input-number v-model="editForm.level" :min="1" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="等级名称" prop="name">
          <el-input v-model="editForm.name" placeholder="例如：青铜会员、白银会员"></el-input>
        </el-form-item>
        <el-form-item label="投资金额" prop="invest_amount">
          <el-input-number v-model="editForm.invest_amount" :precision="2" :step="100" :min="0" controls-position="right" style="width: 200px;"></el-input-number>
          <span class="unit">USDT</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editSubmit">提交</el-button>
        <el-button @click="editDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryinfo: {
        query: '',
        page: 1
      },
      vipLevelList: [],
      total: 0,
      loading: true,
      addForm: {
        level: 1,
        name: '',
        invest_amount: 0
      },
      editForm: {
        id: '',
        level: 1,
        name: '',
        invest_amount: 0
      },
      rules: {
        level: [
          { required: true, message: '请输入VIP等级', trigger: 'blur' },
          { type: 'number', message: 'VIP等级必须为数字', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入等级名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在1到50个字符', trigger: 'blur' }
        ],
        invest_amount: [
          { required: true, message: '请输入投资金额', trigger: 'blur' },
          { type: 'number', message: '投资金额必须为数字', trigger: 'blur' }
        ]
      },
      addDialogVisible: false,
      editDialogVisible: false
    }
  },
  created() {
    this.getlist()
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '--'
      const date = new Date(timestamp * 1000)
      return date.toLocaleString()
    },
    // 获取VIP等级列表
    async getlist() {
      this.loading = true
      try {
        const { data } = await this.$http.get('/admin/user/vipLevelList', {
          params: this.queryinfo
        })
        if (data.code === 200) {
          this.vipLevelList = data.data.list
          this.total = data.data.total
        } else {
          this.$message.error(data.msg || '获取数据失败')
        }
      } catch (error) {
        console.error('获取VIP等级列表失败', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    // 分页事件
    changepage(val) {
      this.queryinfo.page = val
      this.getlist()
    },
    // 添加VIP等级弹窗
    addVipLevel() {
      this.addDialogVisible = true
      this.addForm = {
        level: 1,
        name: '',
        invest_amount: 0
      }
      // 下一帧重置表单验证
      this.$nextTick(() => {
        if (this.$refs.addFormRef) {
          this.$refs.addFormRef.clearValidate()
        }
      })
    },
    // 提交添加
    addSubmit() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        try {
          const { data } = await this.$http.post('/admin/user/addVipLevel', this.addForm)
          if (data.code === 200) {
            this.$message.success('添加成功')
            this.addDialogVisible = false
            this.getlist()
          } else {
            this.$message.error(data.msg || '添加失败')
          }
        } catch (error) {
          console.error('添加VIP等级失败', error)
          this.$message.error('添加失败')
        }
      })
    },
    // 编辑VIP等级
    async edit(id) {
      try {
        const { data } = await this.$http.get('/admin/user/getVipLevel', {
          params: { id }
        })
        if (data.code === 200) {
          this.editForm = data.data
          this.editDialogVisible = true
          this.$nextTick(() => {
            if (this.$refs.editFormRef) {
              this.$refs.editFormRef.clearValidate()
            }
          })
        } else {
          this.$message.error(data.msg || '获取数据失败')
        }
      } catch (error) {
        console.error('获取VIP等级详情失败', error)
        this.$message.error('获取数据失败')
      }
    },
    // 提交编辑
    editSubmit() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        try {
          const { data } = await this.$http.post('/admin/user/editVipLevel', this.editForm)
          if (data.code === 200) {
            this.$message.success('更新成功')
            this.editDialogVisible = false
            this.getlist()
          } else {
            this.$message.error(data.msg || '更新失败')
          }
        } catch (error) {
          console.error('编辑VIP等级失败', error)
          this.$message.error('更新失败')
        }
      })
    },
    // 删除VIP等级
    deleteVipLevel(id) {
      this.$confirm('此操作将永久删除该VIP等级, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await this.$http.post('/admin/user/deleteVipLevel', { id })
          if (data.code === 200) {
            this.$message.success('删除成功')
            this.getlist()
          } else {
            this.$message.error(data.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除VIP等级失败', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.iconfont {
  margin-right: 10px;
  font-size: 16px;
  cursor: pointer;
}
.icon-bianji {
  color: #409eff;
}
.icon-shanchu {
  color: #f56c6c;
}
.unit {
  margin-left: 10px;
  color: #606266;
}
.el-pagination {
  margin-top: 15px;
  text-align: center;
}
</style>
